import { SxProps } from '@mui/material';
import { Box } from '@mui/system';
import { Options } from 'pages/RailroadPage/DisplayOptions';
import { FC, MouseEventHandler } from 'react';
import { RailroadIssueHalfPage } from './RailroadIssueHalfPage';
import { RailroadFullPage } from './utils';

export const RailroadIssueFullPage: FC<{
  pages: RailroadFullPage[];
  pageIndex: number;
  displayOptions: Options;
  containerSx?: SxProps;
  pageSx?: SxProps;
  selected?: boolean;
  onClick?: MouseEventHandler<HTMLDivElement>;
}> = ({
  pages,
  pageIndex,
  containerSx,
  pageSx,
  displayOptions,
  selected,
  onClick,
}) => {
  const [leftPage, rightPage] = pages[pageIndex];
  const prevPage = pages[pageIndex - 1];
  const nextPage = pages[pageIndex + 1];

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: pageIndex === 0 ? 'row-reverse' : 'row',
        ...containerSx,
      }}
    >
      {leftPage && (
        <RailroadIssueHalfPage
          key={leftPage.pageNumber}
          page={leftPage}
          previousPage={prevPage?.[prevPage.length - 1]}
          nextPage={rightPage ?? nextPage?.[0]}
          displayOptions={displayOptions}
          selected={selected}
          onClick={onClick}
          sx={{
            width: '50%',
            ...pageSx,
          }}
        />
      )}
      {rightPage && (
        <RailroadIssueHalfPage
          key={rightPage.pageNumber}
          page={rightPage}
          previousPage={leftPage ?? prevPage?.[prevPage.length - 1]}
          nextPage={nextPage?.[0]}
          displayOptions={displayOptions}
          selected={selected}
          onClick={onClick}
          sx={{
            width: '50%',
            ...pageSx,
          }}
        />
      )}
    </Box>
  );
};
